import { MimeMessageDTO, NotificationDTO } from '@iota/iota-management-portal-v4-client';
import { createAction, props } from '@ngrx/store';

export enum NotificationActionTypes {
    LoadNotificationsByReceiverId = '[Notification] Load Notifications By Receiver Id',
    LoadNotificationsSuccess = '[Notification] Load Notifications Success',
    LoadNotificationsFailure = '[Notification] Load Notifications Failure',

    SendNotification = '[Notification] Send Notification',
    SendNotificationSuccess = '[Notification] Send Notification Success',
    SendNotificationFailure = '[Notification] Send Notification Failure',

    SendMail = '[Notification] Send Mail',
    SendMailSuccess = '[Notification] Send Mail Success',
    SendMailFailure = '[Notification] Send Mail Failure',
    ResetSendMail = '[Notification] Reset Send Mail'
}

export const LoadNotificationsByReceiverId = createAction(
    NotificationActionTypes.LoadNotificationsByReceiverId,
    props<{ userId: string }>()
);
export const LoadNotificationsSuccess = createAction(
    NotificationActionTypes.LoadNotificationsSuccess,
    props<{ notifications: NotificationDTO[] }>()
);
export const LoadNotificationsFailure = createAction(NotificationActionTypes.LoadNotificationsFailure, props<{ error: any }>());

export const SendNotification = createAction(NotificationActionTypes.SendNotification, props<{ notification: NotificationDTO }>());
export const SendNotificationSuccess = createAction(
    NotificationActionTypes.SendNotificationSuccess,
    props<{ notification: NotificationDTO }>()
);
export const SendNotificationFailure = createAction(NotificationActionTypes.SendNotificationFailure, props<{ error: any }>());

export const SendMail = createAction(NotificationActionTypes.SendMail, props<{ mail: MimeMessageDTO }>());
export const SendMailSuccess = createAction(NotificationActionTypes.SendMailSuccess);
export const SendMailFailure = createAction(NotificationActionTypes.SendMailFailure, props<{ error: any }>());
export const ResetSendMail = createAction(NotificationActionTypes.ResetSendMail);
